export default {
  title: 'Highlight',
};
